import { render, staticRenderFns } from "./VerSolicitudModal.vue?vue&type=template&id=5bb7b151&"
import script from "./VerSolicitudModal.vue?vue&type=script&lang=ts&"
export * from "./VerSolicitudModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports